import { AdjustmentsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loading: false,
    error: null,
    adjustments: null,
    pagination: PAGINATION_DEFAULT_VALUE,
};

type AdjustmentsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for adjustments
type State = {
    loading: Boolean,
    error?: null,
    adjustments: any,
    pagination: any,
};

const Adjustments = (state = INIT_STATE, action) => {
    //console.log(action);
    switch (action.type) {
        case AdjustmentsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS: {
                    return {
                        ...state,
                        loading: false,
                        adjustments: action.payload.data.adjustments,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                default:
                    return { ...state, loading: false };
            }

        case AdjustmentsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS: {
                    return { ...state, loading: false, error: action.payload.error };
                }
                default:
                    return { ...state, loading: false };
            }

        case AdjustmentsActionTypes.GET_ALL_ADJUSTMENTS:
            return { ...state, loading: true, adjustments: null };
        case AdjustmentsActionTypes.RESET_STATE:
            return INIT_STATE;
        case AdjustmentsActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Adjustments;
